import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MessagesModule } from 'primeng/messages';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { AuthModule } from 'src/app/auth/auth.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { AddAllegatoCISDialogComponent } from './components/add-allegato-cis-dialog.component';
import { AllegatiRiproduzioneDialogComponent } from './components/allegati-riproduzione-dialog.component';
import { AllegatiShowPasswordComponent } from './components/allegati-show-password.component';
import { AllegatiComponent } from './components/allegati/allegati.component';
import { CISAllegatiComponent } from './components/cisallegati/cis-allegati.component';
import { DistruzioneRestituzioneCISDialogComponent } from './components/distruzione-restituzione-dialog.component';
import { ModificaNoteDialogComponent } from './components/modifica-note-dialog.component';
import { ModificaRiproduzioneDialogComponent } from './components/modifica-riproduzione-dialog.component';
import { PartenzaRiproduzioneDialogComponent } from './components/partenza-riproduzione-dialog.component';
import { RegistersTableComponent } from './components/register-table.component';
import { RevocaDialogComponent } from './components/revoca-dialog.component';
import { RiproduzioniDialogComponent } from './components/riproduzioni-dialog.component';
import { RiproduzioniTableComponent } from './components/riproduzioni-table.component';
import { SpostaFascicoloDialogComponent } from './components/sposta-fascicolo-dialog.component';
import { TabellaStoriciComponent } from './components/tabella-storici.component';
import { TemporarySendDialogComponent } from './components/temporary-send-dialog.component';
import { TrasmettiRiproduzioniDialogComponent } from './components/trasmetti-riproduzioni-dialog.component';
import { VisualizzaToolbarComponent } from './components/visualizza-toolbar.component';
import { VisualizzaComponent } from './visualizza.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { AddAllegatiCondivisiDialogComponent } from './components/add-allegati-condivisi-dialog.component';
import { KeyFilterModule } from 'primeng/keyfilter';
import { FieldsetModule } from 'primeng/fieldset';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    SharedModule,
    ButtonModule,
    DropdownModule,
    InputTextModule,
    InputTextareaModule,
    ToolbarModule,
    DialogModule,
    DataViewModule,
    FileUploadModule,
    CalendarModule,
    CardModule,
    StepsModule,
    TableModule,
    TooltipModule,
    RadioButtonModule,
    ChipsModule,
    CheckboxModule,
    MessagesModule,
    AutoCompleteModule,
    ClipboardModule,
    OverlayPanelModule,
    InputNumberModule,
    AuthModule,
    TableModule,
    KeyFilterModule,
    FieldsetModule
  ],
  exports: [
    VisualizzaComponent,
    SpostaFascicoloDialogComponent
  ],
  declarations: [
    VisualizzaComponent,
    VisualizzaToolbarComponent,
    TabellaStoriciComponent,
    RiproduzioniTableComponent,
    RiproduzioniDialogComponent,
    TrasmettiRiproduzioniDialogComponent,
    AllegatiComponent,
    CISAllegatiComponent,
    AddAllegatoCISDialogComponent,
    DistruzioneRestituzioneCISDialogComponent,
    AllegatiShowPasswordComponent,
    ModificaRiproduzioneDialogComponent,
    ModificaNoteDialogComponent,
    TemporarySendDialogComponent,
    RegistersTableComponent,
    AllegatiRiproduzioneDialogComponent,
    SpostaFascicoloDialogComponent,
    PartenzaRiproduzioneDialogComponent,
    RevocaDialogComponent,
    AddAllegatiCondivisiDialogComponent
  ],
  providers: [],
})
export class VisualizzaModule { }
